import SpriteSymbol from "../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-function",
  "use": "icon-function-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol viewBox=\"0 0 16 16\" id=\"icon-function\"><path d=\"M10 2c-1 0-1.8.8-2 1.9-.1.8-.2 1.9-.4 3.1H6v1h1.5c-.2 1.5-.4 3-.5 3.9-.1.6-.4 1.1-1 1.1s-1-.4-1-1H4c0 1.1.9 2 2 2 1 0 1.9-.8 2-1.9.1-1 .3-2.5.5-4V8H10V7H8.6c.2-1.1.3-2.2.4-2.9.1-.6.4-1.1 1-1.1s1 .4 1 1h1c0-1.1-.9-2-2-2\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol